export default __webpack_public_path__ + "static/media/app-qr-code-bg.d7beec61.png";